const axios = require('axios').default 
//const dotenv = require('dotenv');

//require('dotenv').config();
//dotenv.config({ path: __dirname + '.env' });
////dotenv.config();


const api = axios.create({

    baseURL: 'http://localhost:8000/',
     headers: {  'Content-Type': 'application/json' ,
                  'Accept': 'application/json' ,
                  'Ocp-Apim-Subscription-Key': '7dd8066395d340c0bd38f082f17e71e0',
}
}
    )


export default api;

